import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container, Title, Description } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindow } from '@fortawesome/pro-solid-svg-icons/faWindow';
import { COLORS } from '../../../themes';
import { useWindowDimensions } from '../../../utils/hooks/dimensions';
var SmallScreenWarning = function () {
    var width = useWindowDimensions().width;
    if (width > 1000) {
        return null;
    }
    return (_jsxs(Container, { children: [_jsx(FontAwesomeIcon, { color: COLORS.redColor, size: "3x", icon: faWindow }), _jsx(Title, { children: "The browser is too small" }), _jsx(Description, { children: "Increase your browser width to be at least " }), _jsx(Description, { children: " 1000px to continue working on Appspotr " })] }));
};
export default SmallScreenWarning;
